var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text row smallwidth"},[_c('div',{staticClass:"col"},[_c('h1',{staticClass:"zzgray",domProps:{"innerHTML":_vm._s(_vm.b.header)}}),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.b.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }